<div class="border rounded-md p-5 flex gap-5">
	<div role="status" class="flex max-w-sm animate-pulse">
		<div class="flex-shrink-0">
			<span
				class="flex justify-center items-center bg-gray-300 w-8 h-8"></span>
		</div>
		<div class="ml-4 mt-2 w-full">
			<div class="h-3 bg-gray-300 rounded-full w-48 mb-4"></div>
		</div>
	</div>
</div>
